import type { RouteLocationNormalized, NavigationGuardNext, RouteRecordRaw } from 'vue-router';

export const proxyRouterList: RouteRecordRaw[] = [
    {
        path: '/pwa',
        /**
         * vue-router 3.x 不支持 component 为 undefined
         */
        component: () => {},
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
            next({
                replace: true,
                path: '/home',
            });
        },
    }
]
